var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ReChannelPostAdd pb-3"},[_c('ReFormPrinter',{attrs:{"masFormConfig":_vm.masAllFormParams,"SuccessBtnText":"Отправить"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }